export enum ELocaleStotageMigrationKeys {
  clearAllAnimalsTableColumns = 'clearAllAnimalsTableColumnsV4',
  clearAllAnimalsTableFilters = 'clearAllAnimalsTableFiltersV2',
  clearOnlyAllAnimalsTableColumns = 'clearOnlyAllAnimalsTableColumnsV2',
  clearPropertyDetailsTables = 'clearPropertyDetailsTablesV1',
  clearPropertiesTableColumns = 'clearPropertiesTableColumnsV1',
}

export const migrateTableStorage = (
  path: string,
  versionKey: string,
  storageKeyCheck: 'exact' | 'endsWith' | 'startsWith' | 'includes' = 'exact'
) => {
  const alreadyCleaned = localStorage.getItem(versionKey);
  if (alreadyCleaned) {
    return;
  }

  const allKeys = Object.keys(localStorage);

  const shouldRemove = (key: string) => {
    switch (storageKeyCheck) {
      case 'startsWith':
        return key.startsWith(path);
      case 'endsWith':
        return key.endsWith(path);
      case 'includes':
        return key.includes(path);
      case 'exact':
      default:
        return key === path;
    }
  };

  allKeys.filter(shouldRemove).forEach((key) => localStorage.removeItem(key));

  localStorage.setItem(versionKey, 'true');
};
